import { APIProvider, GoogleMapsContext, Map } from "@vis.gl/react-google-maps";
import { Circle } from "mt-components";
import { useState } from "react";
import { FaTaxi } from "react-icons/fa";

export type PickupPlaceProps = {
  pickupLocationZone: {
    center: { lat: number; lng: number };
    radius: number;
  } | null;
  showLabel?: boolean;
};
export default function PickupPlace({
  pickupLocationZone,
  showLabel,
}: PickupPlaceProps) {
  const [mapInstance, setMapInstance] = useState(null);
  return (
    <APIProvider apiKey={process.env.GOOGLE_MAPS_API_KEY} language={"en"}>
      {showLabel && <p className="DetailTitle">Pickup Area Zone</p>}

      <div style={{ display: "flex", gap: 20 }}>
        <FaTaxi size={40} color={"#d81b60"} />
        <p style={{ marginBottom: 20, fontSize: 14 }}>
          Accomodations within this area zone are eligible for vehicle pickup.
          <br />
          Please enter in your accomodation at checkout.
        </p>
      </div>
      <GoogleMapsContext.Provider value={{ map: mapInstance }}>
        <Map
          id="gmap"
          defaultCenter={pickupLocationZone.center}
          defaultZoom={10}
          zoomControl={true}
          gestureHandling="greedy"
          style={{ height: "400px" }}
          onTilesLoaded={(event) => setMapInstance(event.map)}
        >
          <Circle
            center={pickupLocationZone.center}
            radius={pickupLocationZone.radius}
            mapInstance={mapInstance}
          />
        </Map>
      </GoogleMapsContext.Provider>
    </APIProvider>
  );
}
